import { render, staticRenderFns } from "./retentionRate.vue?vue&type=template&id=5bc4b573&scoped=true"
import script from "./retentionRate.vue?vue&type=script&lang=js"
export * from "./retentionRate.vue?vue&type=script&lang=js"
import style0 from "./retentionRate.vue?vue&type=style&index=0&id=5bc4b573&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc4b573",
  null
  
)

export default component.exports